import React, { useState } from "react";
import OptimusTab from "./OptimusTab";
import OptimusUpdateTab from "./OptimusUpdateTab";
import PolarisTab from "./PolarisTab";
import TallyGreenTab from "./TallyGreenTab";
import MessageLogsTab from "./MessageLogsTab";
import { DashboardNav } from "../../components/dashboard-nav";

const MessagesDashboard = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [activeTab, setActiveTab] = useState("optimus");
  const [searchTerm, setSearchTerm] = useState("");

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="flex h-screen overflow-hidden bg-black text-white w-full">
      <DashboardNav isExpanded={isExpanded} toggleExpand={toggleExpand} />

      <main className="flex-1 overflow-y-auto w-full p-4 md:p-6 lg:p-8 custom-scrollbar relative">
        <div className="max-w-7xl mx-auto flex flex-col h-full">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-white mb-2">
                Messages
              </h1>
              <p className="text-gray-400">
                Manage and send communications to Optimus, Polaris, and Tally Green clients.
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4 w-full">
            <div className="flex space-x-1 bg-[#1e2025] p-1 rounded-md w-max">
              <button
                onClick={() => setActiveTab("optimus")}
                className={`px-6 py-2 rounded-md font-medium transition-all duration-200 ${
                  activeTab === "optimus"
                    ? "bg-[#07F2C7] text-black shadow-sm"
                    : "text-gray-400 hover:text-white hover:bg-[#2b2d36]"
                }`}
              >
                Optimus
              </button>
              <button
                onClick={() => setActiveTab("optimus-update")}
                className={`px-6 py-2 rounded-md font-medium transition-all duration-200 ${
                  activeTab === "optimus-update"
                    ? "bg-[#07F2C7] text-black shadow-sm"
                    : "text-gray-400 hover:text-white hover:bg-[#2b2d36]"
                }`}
              >
                Optimus Update
              </button>
              <button
                onClick={() => setActiveTab("polaris")}
                className={`px-6 py-2 rounded-md font-medium transition-all duration-200 ${
                  activeTab === "polaris"
                    ? "bg-[#07F2C7] text-black shadow-sm"
                    : "text-gray-400 hover:text-white hover:bg-[#2b2d36]"
                }`}
              >
                Polaris
              </button>
              <button
                onClick={() => setActiveTab("tally-green")}
                className={`px-6 py-2 rounded-md font-medium transition-all duration-200 ${
                  activeTab === "tally-green"
                    ? "bg-[#07F2C7] text-black shadow-sm"
                    : "text-gray-400 hover:text-white hover:bg-[#2b2d36]"
                }`}
              >
                Tally Green
              </button>
              <button
                onClick={() => setActiveTab("logs")}
                className={`px-6 py-2 rounded-md font-medium transition-all duration-200 ${
                  activeTab === "logs"
                    ? "bg-[#07F2C7] text-black shadow-sm"
                    : "text-gray-400 hover:text-white hover:bg-[#2b2d36]"
                }`}
              >
                Delivery Logs
              </button>
            </div>
            
            <div className="relative w-full sm:w-72">
              <input
                type="text"
                placeholder="Search by name, phone, email, client ID..."
                className="w-full bg-[#1e2025] text-white border border-[#2b2d36] rounded-md px-4 py-2 outline-none focus:border-[#07F2C7] transition-colors"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>

          <div className="flex-1 flex flex-col min-h-0">
            {activeTab === "optimus" && <OptimusTab searchTerm={searchTerm} />}
            {activeTab === "optimus-update" && <OptimusUpdateTab searchTerm={searchTerm} />}
            {activeTab === "polaris" && <PolarisTab searchTerm={searchTerm} />}
            {activeTab === "tally-green" && <TallyGreenTab searchTerm={searchTerm} />}
            {activeTab === "logs" && <MessageLogsTab searchTerm={searchTerm} />}
          </div>
        </div>
      </main>
    </div>
  );
};

export default MessagesDashboard;
